import styled from "styled-components";
import bg from "../../assets/img/JoinCommunityBg.png";
import bgDark from "../../assets/img/JoinCommunityBgDark.png";

export const JoinCommunityWrapper = styled.div`
  padding: 50px 0 70px;
  background: ${(props) => (props.theme == "dark" ? `url(${bg})` : `url(${bgDark})`)} no-repeat center;
  background-size: contain;
`;

export const JoinCommunityMain = styled.div`
  & h3 {
    font-family: "Poppins";
    font-style: normal;
    font-weight: 700;
    font-size: 48px;
    line-height: 126.2%;
    text-align: center;
    color: ${(props) => props.theme.textColor};
  }
  & span {
    font-family: "Inter";
    font-style: normal;
    font-weight: 400;
    font-size: 20px;
    line-height: 126.2%;
    text-align: center;
    color: ${(props) => props.theme.textColor};
    max-width: 600px;
    display: block;
    margin: 20px auto 40px;
  }
  & button {
    background: ${(props) => props.theme.textColor};
    border-radius: 36px;
    font-family: "Inter";
    font-style: normal;
    font-weight: 500;
    font-size: 20px;
    line-height: 126.2%;
    color: ${(props) => props.theme.body};
    width: 170px;
    height: 46px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    cursor: pointer;
    margin: 0 auto;
    transition: 0.2s;
    &:hover {
      color: ${(props) => props.theme.textColor};
      background: ${(props) => props.theme.body};
      border: 1px solid ${(props) => props.theme.textColor};
      & svg {
        & path {
          fill: ${(props) => props.theme.textColor};
        }
      }
    }
    & svg {
      margin-left: 10px;
      & path {
        transition: 0.2s;
        fill: ${(props) => props.theme.body};
      }
    }
  }
`;
